import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	align-items: center;
	justify-content: center;
`;
